module.exports = __webpack_public_path__ + "img/women-day-rafiki.8836c9ec.svg";